// extracted by mini-css-extract-plugin
export default {"paper":"Notifications_paper__vkpBu","input":"Notifications_input__1QKjE"};